export const THIRD_PARTY_BANNER_DISMISSED_KEY = 'atlassian.search-ai.3p-banner-dismissed';
